<!--begin::Main-->
<div class="d-flex flex-column flex-root">
	<!--begin::Login-->
	<div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
		<!--begin::Aside-->
		<div class="login-aside d-flex flex-column flex-row-auto"
			style="box-shadow: inset -10px 0px 10px -10px rgba(0,0,0,0.5);">
			<!--begin::Aside Bottom-->
			<div class="aside-img d-flex flex-row-fluid">
				<img src="assets/images/FPC.png" alt="FPC Image">
				<div class="caption">Veterinary Management</div>
			</div>
			<!--end::Aside Bottom-->
		</div>
		<!--end::Aside-->
		<div class="login-content flex-row-fluid d-flex flex-column p-10">
			<div class="d-flex flex-row-fluid flex-center">
				<!--begin::Forgot Password form-->
				<div class="login-form">
					<!--begin::Header-->
					<div class="login-content flex-row-fluid d-flex flex-column">
						<a href="#" class="login-logo pb-xl-15 pb-10">
							<span style="font-size:4rem;font-weight:600;color:#414e91 !important">Univet</span>
						</a>
					</div>
					<!--end::Header-->

					<div class="pb-2 pb-lg-5">
						<div class="text-muted font-weight-bold font-size-h6" (click)="backToLogin()" style="cursor: pointer;">
							<i class="las la-arrow-alt-circle-left"></i> Back to Login
						</div>
						<h3 class="font-weight-bolder text-dark font-size-h5">
							{{ mode === 'verify' ? 'Enter Your Code' : 'Forgot Password' }}
						</h3> <br>
					</div>

					<!--begin::Request mode - ask for email-->
					<ng-container *ngIf="mode === 'request'">
						<p class="text-muted font-size-h6">Enter your account email and we'll send you a one-time code to reset your password.</p>
						<form [formGroup]="requestForm" (ngSubmit)="requestReset()">
							<div class="form-group">
								<input type="email" formControlName="Email" id="Email"
									class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Email"
									[ngClass]="{ 'is-invalid': clicked && requestForm.controls.Email.invalid }"
									required autofocus>
								<div *ngIf="clicked && requestForm.controls.Email.invalid" class="invalid-feedback">
									<div *ngIf="requestForm.controls.Email.errors?.required" class="font-size-h6">Required</div>
									<div *ngIf="requestForm.controls.Email.errors?.email" class="font-size-h6">Invalid email format</div>
								</div>
							</div>
							<div *ngIf="errorMessage" class="text-danger font-weight-bold font-size-h6 mb-4">{{ errorMessage }}</div>
							<div class="form-group">
								<button type="submit" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
									[disabled]="isAuthenticating" style="background-color:#182845">
									{{ isAuthenticating ? 'Sending code...' : 'Send Code' }} &nbsp;<i *ngIf="isAuthenticating" class="fas fa-spinner fa-spin"></i>
								</button>
							</div>
						</form>
					</ng-container>
					<!--end::Request mode-->

					<!--begin::Verify mode - enter OTP + new password-->
					<ng-container *ngIf="mode === 'verify'">
						<p class="text-muted font-size-h6">We've sent a one-time code to your email. Enter it below along with your new password.</p>
						<form [formGroup]="verifyForm" (ngSubmit)="verifyAndReset()">
							<div class="form-group">
								<input type="text" formControlName="Otp" id="Otp" inputmode="numeric" maxlength="6"
									class="form-control h-auto py-4 px-8 font-size-h6" placeholder="6-digit code"
									[ngClass]="{ 'is-invalid': clicked && verifyForm.controls.Otp.invalid }"
									required autofocus>
								<div *ngIf="clicked && verifyForm.controls.Otp.invalid" class="invalid-feedback">
									<div *ngIf="verifyForm.controls.Otp.errors?.required" class="font-size-h6">Required</div>
								</div>
							</div>
							<div class="form-group">
								<input type="password" formControlName="NewPassword" id="NewPassword"
									class="form-control h-auto py-4 px-8 font-size-h6" placeholder="New Password"
									[ngClass]="{ 'is-invalid': clicked && verifyForm.controls.NewPassword.invalid }"
									required>
								<div *ngIf="clicked && verifyForm.controls.NewPassword.invalid" class="invalid-feedback">
									<div *ngIf="verifyForm.controls.NewPassword.errors?.required" class="font-size-h6">Required</div>
								</div>
							</div>
							<div class="form-group">
								<input type="password" formControlName="ConfirmPassword" id="ConfirmPassword"
									class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Confirm New Password"
									[ngClass]="{ 'is-invalid': clicked && verifyForm.controls.ConfirmPassword.invalid }"
									required>
								<div *ngIf="clicked && verifyForm.controls.ConfirmPassword.invalid" class="invalid-feedback">
									<div *ngIf="verifyForm.controls.ConfirmPassword.errors?.required" class="font-size-h6">Required</div>
								</div>
							</div>
							<div *ngIf="errorMessage" class="text-danger font-weight-bold font-size-h6 mb-4">{{ errorMessage }}</div>
							<div class="form-group">
								<button type="submit" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
									[disabled]="isAuthenticating" style="background-color:#182845">
									{{ isAuthenticating ? 'Resetting...' : 'Reset Password' }} &nbsp;<i *ngIf="isAuthenticating" class="fas fa-spinner fa-spin"></i>
								</button>
							</div>
						</form>
					</ng-container>
					<!--end::Verify mode-->
				</div>
				<!--end::Forgot Password form-->
			</div>
		</div>
	</div>
</div>
